module.exports = __webpack_public_path__ + "img/unlock2_w.c1eb013a.svg";